import axios from 'axios';
import { AppSetting, AppProperties, GetAppURL } from '../common/function';

var axiosClient = null;


//Create a Funtion to Initialize Axios with Proper Header
var initAxios = function() {
  /**
   * Create an Axios Client with defaults
   */
  const appURL = GetAppURL()
//   const appProperties = AppProperties();
  if(appURL){
    const client = axios.create({
      baseURL: appURL,
      json: true,
      timeout: 100000
    });
  
    axiosClient = client;
  }else{
    setTimeout(() => {
      initAxios();
    },5000)
  }
};

/**
 * ApiRequestService Wrapper with default success/error actions
 */
const ApiRequestService = function(options) {
  if(axiosClient == null ){
    initAxios();
  }
  const appProperties = AppProperties();
  const appSetting = AppSetting();
  const onSuccess = function(response) {
    
    return response;
  };

  const onError = function(error) {
    console.error('Request Failed:');

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error

      console.error('Error Message:', error.message);
      let loginAttempt = window.localStorage.getItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttempt`);
      if (loginAttempt < 5) {
        window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_loginAttempt`, loginAttempt + 1);
        //Do a Redirect
        window.location = appProperties.appURL;
      }
    }

    return Promise.reject(error.response || error.message);
  };
  axiosClient.interceptors.request.use(request => {
    //Add Headers Here
    if(window.localStorage.getItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`)){
      request.headers['Authorization'] = 'Token ' + window.localStorage.getItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`);
    }
    request.headers['content-type'] = 'application/json';

    return request;
  });
  axiosClient.interceptors.response.use(
    res => {
      //Validate Result Before Passing over to Controller

      if (res !== null && res !== undefined) {
        if (res.status !== undefined && res.status === 200) {
          return res;
        } else {
          console.error('Server Returned Error -', res.status);
        }
      } else {
        console.error('Server Returned Empty Response');
      }
      return Promise.reject(res);
    },
    error => {
      if (
        error.config &&
        error.response &&
        error.response.status === 401 &&
        appProperties.enableLogin
      ) {
        //return new Promise(resolve=>);
        console.log('error',error);
        
        return new Promise(resolve => {
          axiosClient({
            method: 'post',
            url: '/login'
          })
            .then(token => {
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_token`, token.data.authtoken);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`, token.data.GivenName);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`, token.data.UnixEpoch);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_emailid`, token.data.emailid);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`, token.data.USER_NAME);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`, token.data.role);
              window.localStorage.setItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_syncAccess`, token.data.syncAccess);

              error.config.headers.Authorization =
                'Token ' + token.data.authtoken;

              return resolve(axios.request(error.config));
            })
            .catch(error => {
              if (error.response) {
                // Request was made but server responded with something
                // other than 2xx
                console.debug('Adding Token Failed: ');
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
                console.error('Headers:', error.response.headers);
              }
            });
        });
      }

      return Promise.reject(error);
    }
  );

  return axiosClient(options)
    .then(onSuccess)
    .catch(onError);
};

export default ApiRequestService;
